export const LogoMark = ({ className = "h-7 w-7", variant = "auto" }) => {
  const base = `${className} shrink-0 object-contain`;
  if (variant === "light") {
    return <img src="/offcraft-logo-light.png" alt="" aria-hidden="true" className={base} />;
  }
  return (
    <>
      <img src="/offcraft-logo.png" alt="" aria-hidden="true" className={`${base} dark:hidden`} />
      <img src="/offcraft-logo-light.png" alt="" aria-hidden="true" className={`${base} hidden dark:block`} />
    </>
  );
};

export const Logo = ({ className = "", variant = "auto" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <LogoMark className="h-8 w-8" variant={variant} />
    <span className={`font-display text-lg font-extrabold tracking-[0.14em] ${variant === "light" ? "text-white" : "text-ink"}`}>
      OFFCRAFT
    </span>
  </span>
);
